import { useShare } from '../hooks/useShare';

const ShareLabel = () => {
	const { shareLabelClass } = useShare();

	return (
		<div
			className={`shareLabel vtex-store-components-3-x-shareLabel ${shareLabelClass ? shareLabelClass : 'c-muted-2 t-small mb3'}`}
		>
			Compartilhe
		</div>
	);
};

export default ShareLabel;
